import 'slick-carousel';

export function partnersSlider() {
  $('.home-partners__logos').slick({
    slidesToShow: 5,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 3000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
      },
    }, {
      breakpoint: 601,
      settings: {
        slidesToShow: 3,
      },
    }, {
      breakpoint: 481,
      settings: {
        slidesToShow: 3,
      },
    }, {
      breakpoint: 376,
      settings: {
        slidesToShow: 3,
      },
    }],
  });
}



// WEBPACK FOOTER //
// ./scripts/components/partnersSlider.js